import { Component } from '@angular/core';

@Component({
  selector: 'app-error-layout',
  template: `
    <div class="min-vh-100 d-flex flex-column">
      <app-top-bar></app-top-bar>
      <div class="d-flex flex-row flex-grow-1">
        <div class="main p-4 flex-grow-1">
          <router-outlet></router-outlet>
        </div>
      </div>
      <app-bottom-bar></app-bottom-bar>
    </div>
  `,
  styles: [],
})
export class ErrorLayoutComponent {}
